import { useEffect, useRef } from 'react';
import ProductCard from '../components/ProductCard';
import { useData } from '../contexts/DataContext';
import { Link } from 'react-router-dom';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function HomePage() {
  const { products, loading } = useData();
  const productsRef = useRef(null);



  // Animations
  useEffect(() => {
    if (loading) {
      console.log('⏳ HomePage: Products still loading, skipping animations');
      return;
    }

    console.log('🎨 HomePage: Starting animations');


    const productCards = productsRef.current?.querySelectorAll('[data-testid^="product-card-"]');
    if (productCards && productCards.length > 0) {
      console.log(`🎨 HomePage: Animating ${productCards.length} product cards`);
      gsap.fromTo(
        productCards,
        { opacity: 0, y: 40 },
        {
          opacity: 1,
          y: 0,
          duration: 0.6,
          stagger: 0.05,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: productsRef.current,
            start: 'top 80%',
          },
        }
      );
    } else {
      console.warn('⚠️ HomePage: No product cards found for animation');
    }
  }, [loading, products]);

  return (
    <div className="min-h-screen" data-testid="home-page">
      {/* Popüler Ürünler Bölümü */}
      <section className="py-8 md:py-12 bg-white border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="flex items-center justify-between mb-6">
            <h2 className="font-manrope font-bold text-2xl md:text-3xl">
              Popüler Ürünler
            </h2>
            <Link
              to="/kategori/tum-urunler"
              className="text-trendyol-orange font-medium hover:underline text-sm md:text-base"
            >
              Tümünü Gör
            </Link>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-4">
            {products.slice(0, 6).map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        </div>
      </section>

      {/* İndirim Kuponları Bölümü */}
      <section className="py-8 md:py-12 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <h2 className="font-manrope font-bold text-2xl md:text-3xl mb-6 text-center">
            İndirim Kuponları
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="bg-gradient-to-br from-purple-400 to-purple-600 rounded-2xl p-6 text-center text-white shadow-lg hover:scale-105 transition-transform cursor-pointer">
              <div className="text-5xl font-bold mb-2">%5</div>
              <div className="text-sm font-medium">ve üzeri indirim</div>
            </div>
            <div className="bg-gradient-to-br from-green-400 to-green-600 rounded-2xl p-6 text-center text-white shadow-lg hover:scale-105 transition-transform cursor-pointer">
              <div className="text-5xl font-bold mb-2">%10</div>
              <div className="text-sm font-medium">ve üzeri indirim</div>
            </div>
            <div className="bg-gradient-to-br from-blue-400 to-blue-600 rounded-2xl p-6 text-center text-white shadow-lg hover:scale-105 transition-transform cursor-pointer">
              <div className="text-5xl font-bold mb-2">%30</div>
              <div className="text-sm font-medium">ve üzeri indirim</div>
            </div>
            <div className="bg-gradient-to-br from-pink-400 to-pink-600 rounded-2xl p-6 text-center text-white shadow-lg hover:scale-105 transition-transform cursor-pointer">
              <div className="text-5xl font-bold mb-2">%50</div>
              <div className="text-sm font-medium">ve üzeri indirim</div>
            </div>
          </div>
        </div>
      </section>


      <section ref={productsRef} className="py-12 md:py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="flex items-center justify-between mb-6">
            <h2 className="font-manrope font-bold text-2xl md:text-3xl">
              Sizin İçin Seçtiklerimiz
            </h2>
            <Link
              to="/kategori/tum-urunler"
              className="text-trendyol-orange font-medium hover:underline"
              data-testid="view-all-products"
            >
              Tümünü Gör
            </Link>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-4">
            {products.slice(0, 10).map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        </div>
      </section>

      <section className="py-12 md:py-16 bg-trendyol-orange-soft">
        <div className="max-w-7xl mx-auto px-4 md:px-8 text-center">
          <h2 className="font-manrope font-bold text-3xl md:text-4xl mb-4">
            Hemen İndirin, Avantajlı Alışverişe Başlayın!
          </h2>
          <p className="text-lg text-gray-700 mb-8">
            Mobil uygulamadan alışveriş yapın, özel indirimlerden yararlanın.
          </p>
          <div className="flex gap-4 justify-center">
            <button className="bg-trendyol-dark text-white px-8 py-3 rounded-lg font-medium hover:bg-gray-800 transition-colors">
              App Store
            </button>
            <button className="bg-trendyol-dark text-white px-8 py-3 rounded-lg font-medium hover:bg-gray-800 transition-colors">
              Google Play
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
